module.exports = __webpack_public_path__ + "static/media/sheer-dream.4439d5c9.png";